<template>
  <div class="boxSR" style="margin-top:20px">
    <div>
      <el-form-item label="收款方:" prop="payCustomerName" v-if="goodform.generalCarrier">
        {{goodform.generalCarrier}}
      </el-form-item>
      <div v-else>
        <el-form-item label="收款类型"  prop="collectionType" >
          <template >
            <el-radio-group v-model="goodform.collectionType"   @change="collectionTypeFn">
              <el-radio :label="1" >企业</el-radio>
              <el-radio :label="2">司机</el-radio>
              <el-radio :label="3">车队长</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item label="收款方:" prop="payer" :rules="[{ required: true, message: '请选择收款方', trigger: 'blur' }]" class="width1" v-if="goodform.collectionType==1">
          <el-select  v-model="goodform.payer" filterable placeholder="请选择"  @change="payerChange">
            <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款方:" label-width="120px"  v-if="goodform.collectionType==2">
          {{goodform.driverName}}
        </el-form-item>
        <el-form-item label="车队长姓名:"  prop="payer" label-width="120px"  v-if="goodform.collectionType==3">
          <!-- <el-input  placeholder=""    maxlength="50" v-model="goodform.payer"  ></el-input> -->
          <el-autocomplete class="inline-input" v-model.trim="goodform.payer"
              :fetch-suggestions="querySearch" value-key="payerTaxId" @select="handleSelect" popper-class="xiala">
                <template slot-scope="{ item }">
                    <div style="position: relative;">
                    <div class="name">{{ item.payer }} / {{ item.payerTaxId? item.payerTaxId:''}}</div>
                  </div>
              </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="身份证号:" prop="payerTaxId" label-width="120px" v-if="goodform.collectionType==3">
          <el-input  placeholder=""    maxlength="50" v-model="goodform.payerTaxId"  ></el-input>
        </el-form-item>
      </div>
    </div>
    <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border >
      <el-table-column label="支出方式" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>支出方式</div>
        </template>
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="expenditurePattern" >
              <el-select  v-model="goodform.expenditurePattern"  placeholder="请选择"  @change="zcfsChange">
                <el-option v-for="item in ZHFSlist"  :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费计价" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费计价</div>
        </template>
        <template >
          <div>
            <el-form-item label=""    class="table_error" prop="freightPricingType">
              <el-select  v-model="goodform.freightPricingType"  placeholder="请选择" @change="jijiaChange">
                <template  v-for="item in SRJJlist">
                     <el-option  :label="item.showName" v-if="item.showName.includes(goodform.measuringUnit)||item.showName=='包干'" :value="item.itemNo" :key="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费单价(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费单价(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""   class="table_error" prop="freightUnitPrice"  v-if="goodform.freightPricingType!=1">
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="goodform.freightUnitPrice"  ></el-input>
            </el-form-item>
             <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费金额(元)" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>运费金额(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="allFreightAmount" >
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.allFreightAmount"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费率%" min-width="120" >
        <template slot="header" >
          <div><span class="red">*</span>服务费率%</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="serviceRate"  >
              <el-input  placeholder=""  v-number-input.float="2" :readonly="goodform.WHJKflag==1"   maxlength="8" v-model="goodform.serviceRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="服务费(元)" min-width="120" >
        <template slot="header" >
          <div><span class="red">*</span>服务费(元)</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error"  prop="serviceCharge">
              <el-input  placeholder=""  v-number-input.float="2" :readonly="true"  maxlength="8" v-model="goodform.serviceCharge"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出附加费(元)" min-width="120">
        <template >
          <div>
            <el-form-item label=""  class="table_error" >
              <span v-if="this.goodform.reverseCountFlag == 1">-</span>
              <div v-else style="display:flex;">
                <!-- <el-select  v-model="goodform.disburseSurchargeFlag" style="width:70px">
                  <el-option  label="增项" :value="1" ></el-option>
                  <el-option  label="减项" :value="2" ></el-option>
                </el-select> -->
                <el-input  placeholder=""   oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"  maxlength="8"
                v-model="goodform.disburseSurcharge"  ></el-input>
              </div>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出备注" min-width="120">
        <template >
          <div>
            <el-form-item label=""   class="table_error" >
              <el-input  placeholder=""   maxlength="50" v-model="goodform.freightRemark"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运费税率%" min-width="130" >
        <template slot="header" >
          <div><span class="red">*</span>运费税率%</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="freightTaxRate">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.freightTaxRate"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支出含税(元)" min-width="130" >
        <template >
          <div>
            <el-form-item label=""  class="table_error" prop="freightTaxRate">
              <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.zchs"  ></el-input>
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getDictionaryDetailList, findCustomerInfoList, findVehicleLeaderList, findPriceVehicleList } from '@/api/newTMS'
import { selectTMSTenantListByCustom } from '@/api/newCrm'
import { toFixed } from '@/utils/util'
export default {
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      ZHFSlist: [],
      SRJJlist: [],
      CYSList: [],
      isInitialized: false
    }
  },
  created () {
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'freightTaxRate', 9)
    getDictionaryDetailList({ dictionaryType: 'down_settlement_type' }).then(res => { this.ZHFSlist = res })
    getDictionaryDetailList({ dictionaryType: 'settlement_pricing' }).then(res => { this.SRJJlist = res })
    findCustomerInfoList({ businessType: 2 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => { this.CYSList = res1 })
    })
    setTimeout(() => {
      this.isInitialized = true
    }, 3000)
  },
  methods: {
    querySearch (str, cb) {
      findVehicleLeaderList({ payer: str }).then(res => {
        cb(res)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handleSelect (row) {
      this.$set(this.goodform, 'payer', row.payer)
      this.$set(this.goodform, 'payerTaxId', row.payerTaxId)
    },
    // 收款方类型改变
    collectionTypeFn () {
      this.$set(this.goodform, 'payer', '')
      this.$set(this.goodform, 'payerTaxId', '')
      this.$set(this.goodform, 'payerCode', '')
    },
    // 收款方改变
    payerChange (e) {
      let json = this.CYSList.filter(item => item.customerName == this.goodform.payer)
      this.goodform.payerTaxId = json[0].customerTaxId
      this.goodform.payerCode = json[0].tenantCode
    },
    // 支出方式修改
    zcfsChange (e) {
      let json = this.ZHFSlist.filter(item => item.itemNo == e)
      this.goodform.expenditurePatternName = json[0].showName
    },
    // 运费计价修改
    jijiaChange (e) {
      let json = this.SRJJlist.filter(item => item.itemNo == e)
      this.goodform.freightPricingTypeName = json[0].showName
      if (this.goodform.freightPricingType == 1) {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'allFreightAmount', '')
      } else {
        this.$set(this.goodform, 'freightUnitPrice', '')
        this.$set(this.goodform, 'allFreightAmount', '')
      }
    },
    // 获取自由车价格
    getziyouchePriceFn () {
      if (this.goodform.vehicleOwnership == 1) {
        return
      }
      if (this.goodform.productTypeName && this.goodform.startDirection && this.goodform.endDirection && this.goodform.energyTypeName && this.goodform.freightPricingTypeName && this.goodform.payee) {
        findPriceVehicleList({
          productTypeName: this.goodform.productTypeName,
          startDirection: this.goodform.startDirection,
          endDirection: this.goodform.endDirection,
          energyTypeName: this.goodform.energyTypeName,
          freightPricingTypeName: this.goodform.freightPricingTypeName,
          payee: this.goodform.payee,
          arriveDepartFlag: this.goodform.arriveDepartFlag,
          needLength: this.goodform.needLength
        }).then(res => {
          if (res.price) {
            if (this.goodform.freightPricingType == 1) { // 包干
              this.$set(this.goodform, 'allFreightAmount', res.price)
              this.$set(this.goodform, 'freightUnitPrice', '')
            } else {
              this.$set(this.goodform, 'freightUnitPrice', res.price)
              this.$set(this.goodform, 'allFreightAmount', '')
            }
            this.$set(this.goodform, 'disburseSurcharge', res.disburseSurcharge)
          } else {
            // this.$set(this.goodform, 'allFreightAmount', '')
            // this.$set(this.goodform, 'freightUnitPrice', '')
            // this.$set(this.goodform, 'disburseSurcharge', '')
          }
        })
      }
    }

  },
  computed: {
    ziyouchePriceChange () {
      const { productType, startDirection, endDirection, energyType, freightPricingType, payee, arriveDepartFlag } = this.goodform
      return { productType, startDirection, endDirection, energyType, freightPricingType, payee, arriveDepartFlag }
    }
  },
  watch: {
    ziyouchePriceChange: {
      handler (newVal, oldVal) {
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          if (this.isInitialized) {
            this.getziyouchePriceFn()
          }
        }
      }
    },
    goodform: {
      handler (newName, oldName) {
        if (this.goodform.liquidatedAmount && this.goodform.freightUnitPrice) {
          this.$set(this.goodform, 'allFreightAmount', toFixed(accMul(this.goodform.liquidatedAmount, this.goodform.freightUnitPrice), 2))
        }
        // 网货反算。服务费 = 运费/（1-服务费率）* 服务费率  合计 = 运费 /（1-服务费率）
        if (this.goodform.reverseCountFlag == 1) {
          if (this.goodform.allFreightAmount && this.goodform.serviceRate) {
            let n = this.goodform.serviceRate / 100
            this.$set(this.goodform, 'serviceCharge', toFixed(this.goodform.allFreightAmount / (1 - n) * n, 2))
          } else {
            this.$set(this.goodform, 'serviceCharge', 0)
          }
        } else {
          if (this.goodform.allFreightAmount && this.goodform.serviceRate) {
            let fujiafei = this.goodform.disburseSurcharge && !isNaN(Number(this.goodform.disburseSurcharge)) ? Number(this.goodform.disburseSurcharge) : 0
            let n = this.goodform.serviceRate / 100
            let all = toFixed((Number(this.goodform.allFreightAmount) + fujiafei), 2)
            this.$set(this.goodform, 'serviceCharge', toFixed(accMul(all, n), 2))
          } else {
            this.$set(this.goodform, 'serviceCharge', 0)
          }
        }
        let fwf = Number(this.goodform.serviceCharge)
        let yufei = Number(this.goodform.allFreightAmount)
        if (this.goodform.serviceCharge && this.goodform.allFreightAmount) {
          this.$set(this.goodform, 'zchs', toFixed((fwf + yufei), 2))
        } else {
          this.$set(this.goodform, 'zchs', '')
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
</style>
